import { render, staticRenderFns } from "./TabPopup.vue?vue&type=template&id=90ad3744&scoped=true"
import script from "./TabPopup.vue?vue&type=script&lang=js"
export * from "./TabPopup.vue?vue&type=script&lang=js"
import style0 from "./TabPopup.vue?vue&type=style&index=0&id=90ad3744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ad3744",
  null
  
)

export default component.exports